import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import CapabilityCircle from '../../user/CapabilityCircle';
export default function CarrierStatus({ userType, rows }) {
    const { t } = useTranslation();
    return (React.createElement("table", { className: "mt-6 default-table" },
        React.createElement("thead", null,
            React.createElement("tr", null,
                userType === 'shipper' && React.createElement("th", null, t('SHIPPER')),
                userType === 'carrier' && React.createElement("th", null, t('CARRIER')),
                React.createElement("th", null, t('STATUS')),
                React.createElement("th", null, t('MESSAGE')))),
        React.createElement("tbody", null, rows.map((row) => (React.createElement(CarrierRow, { key: row.shipper, row: row }))))));
}
function CarrierRow({ row }) {
    const { userId, status, success, name } = row;
    function renderCarrierRowLink() {
        const link = `/users/${userId}`;
        return (React.createElement(Link, { to: link },
            React.createElement("span", null, name)));
    }
    return (React.createElement("tr", null,
        React.createElement("td", null, renderCarrierRowLink()),
        React.createElement("td", null,
            React.createElement(CapabilityCircle, { checked: success })),
        React.createElement("td", null, status)));
}
